import { adaptShortList } from 'stores/adapters/bex-api/migration-adapters/common/shortlist-adapter';

import { BadgeModel, HotelDetailsViewModel, OverviewViewModel } from 'models';

import { hasAmenities, updateAdditionalInfo } from './property-info-amenities-adapter';
import { LodgingEnrichedMessage, OperationResult, PropertyInfoDetails } from 'src/common/__generated__/api';

export const adaptPropertyInfoDetails = (response: OperationResult<PropertyInfoDetails.Query>): HotelDetailsViewModel => {
  const propertyInfo = response?.data?.propertyInfo;
  const hotel = {} as any;

  if (!propertyInfo) {
    return hotel;
  }

  hotel.region = propertyInfo?.summary?.location?.parentRegion;
  hotel.hotelName = propertyInfo.summary?.name;
  hotel.hotelOverviewA11yHeader = propertyInfo.summary?.overview?.accessibilityLabel;
  hotel.overview = adaptOverview(propertyInfo);
  hotel.propertyHighlightedDetails = propertyInfo?.propertyHighlightedDetails;

  hotel.feedbackModel = {
    feedbackText: propertyInfo.feedback?.action?.text,
  };

  if (hasAmenities(propertyInfo)) {
    hotel.additionalInfo = hotel.additionalInfo || {};
    hotel.additionalInfo = updateAdditionalInfo(hotel.additionalInfo, propertyInfo.summary.amenities?.amenities);
  }

  hotel.featuredMessages = adaptFeaturedMessages(propertyInfo.summary?.featuredMessages);

  hotel.structure = propertyInfo.summary?.structure;

  // When removing adapt code after PDP migration finished, could set configs on the view:
  // https://github.expedia.biz/Brand-Expedia/shopping-pwa/blob/master/src/common/components/infosite/rooms-and-rates/index.tsx#L482
  // Example on hotel landing page:
  // https://github.expedia.biz/Brand-Expedia/shopping-pwa/blob/master/src/common/views/hotel/home.jsx#L48
  const searchOptions = {
    displayFields: ['dateRange', 'rooms'],
    ignoreFields: ['startDate', 'endDate', 'regionId', 'x_pwa'],
  };
  hotel.changeSearchDisplayOptions = JSON.parse(JSON.stringify(searchOptions));

  if (propertyInfo && propertyInfo.shortList) {
    hotel.shortlistModel = adaptShortList(propertyInfo.shortList);
  }

  return hotel;
};

export const mapImages = (propertyImage: any) =>
  propertyImage && {
    alt: propertyImage.alt,
    caption: propertyImage.image?.description,
    src: propertyImage.image?.url,
    thumbnailSrc: propertyImage.thumbnail?.url,
    fallBackImage: propertyImage.fallbackImage?.url,
    lowResImage: propertyImage.lowResImage?.url,
    subjectId: propertyImage.subjectId,
  };

export function adaptFeaturedMessages(featuredMessages: LodgingEnrichedMessage.Fragment[]): BadgeModel[] {
  return featuredMessages?.map(message => ({
    icon: message.icon?.id,
    text: message.value,
  }));
}

export function adaptOverview(propertyInfo: any): OverviewViewModel {
  const location = propertyInfo?.summary?.location;
  if (!location) {
    return null;
  }

  return {
    addressLine: location.address?.addressLine,
    latitude: location.coordinates?.latitude,
    longitude: location.coordinates?.longitude,
    staticMapSrc: location.overviewStaticMapSrc,
    streetAddress: location.address?.firstAddressLine,
    city: location.address?.city,
    state: location.address?.province,
    countryCode: location.address?.countryCode,
    regionId: location.parentRegion?.id,
  };
}
